import ExcelJS from 'exceljs';

function excelValueToString(value) {
  if (value == null) return "";

  // Primitivos y Date
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) return String(value);

  if (value instanceof Date) return value.toISOString();

  // Objetos típicos de ExcelJS
  if (typeof value === "object") {
    // { text, hyperlink }
    if ("text" in value) return String(value.text ?? "");

    // { richText: [{ text: "..." }, ...] }
    if ("richText" in value && Array.isArray(value.richText)) {
      return value.richText.map(r => r?.text ?? "").join("");
    }

    // { formula, result }
    if ("formula" in value) {
      if ("result" in value) return excelValueToString(value.result);
      return String(value.formula ?? "");
    }

    if ("result" in value) return excelValueToString(value.result);

    return JSON.stringify(value);
  }

  return String(value);
}

export const readXlsxFile = async ({
  xlsxFile
}) => {

  const file = xlsxFile;

  if (!file) return;

  const workbook = new ExcelJS.Workbook();

  try {
    const buffer = await file.arrayBuffer();
    const filename = file?.name ?? 'Archivo desconocido';
    await workbook.xlsx.load(buffer);
    const worksheet = workbook.worksheets[0];

    const rows = [];
    const columnCount = worksheet.columnCount;

    worksheet.eachRow({ includeEmpty: true }, (row) => {

      const newRow = [];

      for (let i = 1; i <= columnCount; i++) {

        const cell = row.getCell(i);

        newRow.push({
          rowIndex: row.number,
          colIndex: i,
          address: cell.address,
          value: excelValueToString(cell.value),
          rawValue: cell.value
        });
      }

      rows.push(newRow);
    });

    return {
      data: {
        rows,
        filename: filename
      }
    }

  } catch (error) {
    console.error('Error al leer el archivo de Excel:', error);
    return {
      error: error.message ?? 'Error al leer el archivo de Excel'
    }
  }
};